module.exports = __webpack_public_path__ + "images/emoji/smirk_cat.5f4f57a4bdf3e9a71349.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/smirk_cat.png
// module id = VCsp
// module chunks = 14